// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9fyPr","item":"styles_item__cczQ9","icon":"styles_icon__hfFuD","label":"styles_label__HYx-E"};